import React,{useEffect,useState} from 'react';
import { useLocation } from 'react-router-dom';
import { Base64 } from 'js-base64';
import { GET_VEHICLE_DETAILS } from '../../constant'; 
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import axios from 'axios';
import moment from 'moment';
import DefaultProfileImage from '../../assets/images/default-profile-img.png';
import {currentDateFormat} from "../../utils";

function VehicleDetails() {
     const dispatch = useDispatch();
  const location = useLocation();
   const [currentDate,setCurrentDate] = useState(new Date());
  const queryParams = new URLSearchParams(location.search);
  const encodedProfileId = queryParams.get('vehicleId');
  const vehicleeId = Base64.decode(encodedProfileId);
  const [driverList, setvehicleList] = useState([]);
    // {console.log(profileId)}
  useEffect(() => {
    const loadUser = async () => {
      try {
        dispatch(setLoading(true));
        const response = await axios.get(GET_VEHICLE_DETAILS + '/' + `${vehicleeId}`);
        if (response.status === '200') {
          dispatch(setLoading(false));
          setvehicleList(response.data);
          // Handle the response data as needed
        }
      } catch (error) {
        console.error("Error fetching driver list:", error);
        dispatch(setLoading(false));
      }
    }
    loadUser();
  }, []);
  return (
    <div className="container">
      <div className="main-body">
        <section>
            <div className='d-flex justify-content-between form-container'>
                <div>
                    <h2 className="fs-5 font-weight-600">Vehicle Details</h2>
                </div>
                <div>
                    <span>{currentDateFormat(currentDate)}</span>
                </div>
            </div>
         </section>
         <div className="row gutters-sm">
           
          <div className="col-md-8">
              <div className="card mb-3">
                <div className="card-body">
                <p className='sub-title'>Personal Information</p>
                <hr/>
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Full Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {`${driverList?.driver_first_name} ${driverList?.driver_middle_name} ${driverList?.driver_last_name}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Gender</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.gender == 1 ? 'Male' :'Female'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Date of birth</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {moment( driverList?.user_dob).format("MM/DD/YYYY") }
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">UMPI Number</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {driverList?.driver.umpi_no}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.user_email ?? ''}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Phone</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.driver.home_phn_no}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Hire Date</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    { driverList?.driver?.hire_date ? moment( driverList?.driver?.hire_date).format("MM/DD/YYYY") : ''}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Renewel Date</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {driverList?.driver?.renewel_date ? moment(driverList?.driver?.renewel_date).format("MM/DD/YYYY") : ''}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Address</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.address_1}, ${driverList?.address_2}, ${driverList?.city}, ${driverList?.state_list.state_name}, ${driverList?.zip}`}
                    </div>
                  </div>
                  <hr />
                  <p className='sub-title'>Emergency Contact Information</p>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Contact Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_contact_name}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Phone Number</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_phn}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_email}`}
                    </div>
                  </div>
                  <hr />
                  {/* <div className="row">
                    <div className="col-sm-12">
                      <a className="btn btn-info " target="__blank" href="https://www.bootdey.com/snippets/view/profile-edit-data-and-skills">Edit</a>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="row gutters-sm" style={{display:'none'}}>
                <div className="col-sm-6 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <h6 className="d-flex align-items-center mb-3"><i className="material-icons text-info mr-2">assignment</i>Project Status</h6>
                      <small>Web Design</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "80%"}} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Website Markup</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "72%"}} aria-valuenow="72" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>One Page</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "89%"}} aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Mobile Template</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "55%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Backend API</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "66%"}} aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <h6 className="d-flex align-items-center mb-3"><i className="material-icons text-info mr-2">assignment</i>Project Status</h6>
                      <small>Web Design</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "80%"}} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Website Markup</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "72%"}} aria-valuenow="72" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>One Page</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "89%"}} aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Mobile Template</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "55%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Backend API</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "66%"}} aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
      </div>
    </div>
  )
}

export default VehicleDetails
